<body>
  <div class="login-card">
    <div class="logo">
    </div>
    <div class="err" id="error"></div>
    <h1>Forgot Password</h1>
    <br />
    <form>
      <label>Email</label>
      <div class="user">
        <input type="text" name="email" [(ngModel)]="screen_details.email" id="email" [pattern]="emailPattern"
          maxlength="40" #email="ngModel" (blur)="checkEmailNames($event.target.value)"
          (input)="clearErroMassages(1)" />
        <span id="emailErr"> </span>
      </div>
      <label>Mobile No</label>
      <div class="user">
        <input type="text" name="mobile" [(ngModel)]="screen_details.mobileno" id="mobile" #mobile="ngModel"
          maxlength="10" [pattern]="mobilePattern" (blur)="checkMobileNo($event.target.value)"
          (input)="clearErroMassages(2)" />
        <span id="mobileNoErr"> </span>
      </div>
      <div class="logdiv" *ngIf="loader == false">
        <span class="text-leftforgot"> <a routerLink="/login">Cancel</a> </span>
        <span class="text-right">
          <input type="submit" name="Submit" id="subMitBtn" class="login login-submit" (click)="submitdata()"
            value="Login" [disabled]="isEmailValid == false || isMobileValid == false" />
        </span>

      </div>
      <ng-container *ngIf="loader == true">
        <div>
          <div style="margin: 0 auto; text-align: center;">
            <img src="../../../../assets/img/Loading_Animation.gif" width="8%" height="8%" alt="Loader" />
          </div>
        </div>
      </ng-container>
    </form>
  </div>
</body>